import React from 'react';
import { Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { LabelLayout } from './styles.js';

const LabelName = ({ name, info, labelStyle, }) => {
    return (React.createElement(LabelLayout, null,
        React.createElement("span", { className: 'label-name', style: labelStyle },
            name,
            info && (React.createElement(Tooltip, { placement: "top", title: info },
                React.createElement(QuestionCircleOutlined, { className: 'label-info-icon' }))))));
};

export { LabelName, LabelName as default };
